export function inJestUnitTest(): boolean {
	return typeof (global as any).inJest !== 'undefined'
}
